import React from 'react';
import { Grid } from "@mui/material";
import TextField from "../../../../../controls/TextField";
import { useFormContext } from "react-hook-form";

export type BidWinRateInput = {
    minAmount: number
    maxAmount: number
}
type Props = {
    minAmount?: number
    maxAmount?: number
}

const BidWinRateForm: React.FC<Props> = ({
    minAmount = 0, maxAmount = 100
}) => {
    const { register, errors, getValues, trigger } = useFormContext();
    return (
        <Grid container alignContent={'flex-start'} justifyContent={'center'} direction={'row'} spacing={2}>
            <Grid item xs={12} sm={5}>
                <TextField defaultValue={minAmount} name={'minAmount'} fullWidth
                    label={'Min Price'}
                    onChange={() => {
                        trigger(['minAmount', 'maxAmount']);
                    }}
                    inputProps={{
                        ref: register({
                            required: 'Required',
                            validate: (v: string) => {
                                const value = Number(v);
                                if (isNaN(value) || value < 0) return 'Not a valid number';
                                const maxRaw = getValues('maxAmount');
                                const max = Number(maxRaw);
                                if (maxRaw !== undefined && maxRaw !== '' && !isNaN(max) && value > max) {
                                    return 'Min Price must be less than or equal to Max Amount';
                                }
                                return true;
                            }
                        }),
                        onChange: () => {
                            trigger(['minAmount', 'maxAmount']);
                        },
                    }}
                    error={Boolean(errors.minAmount)}
                    helperText={errors.minAmount?.message || (errors.minAmount && 'Not a valid number') || ' '}
                />
            </Grid>
            <Grid item xs={12} sm={5}>
                <TextField defaultValue={maxAmount} name={'maxAmount'} fullWidth
                    label={'Max Amount'}
                    onChange={() => {
                        trigger(['minAmount', 'maxAmount']);
                    }}
                    inputProps={{
                        ref: register({
                            required: 'Required',
                            validate: (v: string) => {
                                const value = Number(v);
                                if (isNaN(value) || value < 0) return 'Not a valid number';
                                const minRaw = getValues('minAmount');
                                const min = Number(minRaw);
                                if (minRaw !== undefined && minRaw !== '' && !isNaN(min) && value < min) {
                                    return 'Max Amount must be greater than or equal to Min Price';
                                }
                                return true;
                            }
                        }),
                        onChange: () => {
                            trigger(['minAmount', 'maxAmount']);
                        },
                    }}
                    error={Boolean(errors.maxAmount)}
                    helperText={errors.maxAmount?.message || (errors.maxAmount && 'Must be greater than or equal to min amount') || ' '} />
            </Grid>
        </Grid>
    );
}

export default BidWinRateForm;